import { API } from '@thuas/pd-schemas';
import api from 'helpers/api';
import { callGet, Retrieving } from 'helpers/apiTypes';
import { prepareForBackend, toArrayOfIdObject } from 'helpers/objects';

export type IPage = API['Page']['read'];
export type IPageCreate = API['Page']['create'];
export type IPageUpdate = API['Page']['update'] & {
  sectionsOverwrite?: { id: number }[];
};

function prepareForUpdate(page: IPage): IPageUpdate {
  const updated = prepareForBackend(page, ['id', 'sections']) as IPageUpdate;
  updated.sectionsOverwrite = toArrayOfIdObject(page.sections);
  return updated;
}
function prepareForCreate(page: IPage): IPageCreate {
  return prepareForBackend(
    {
      ...page,
      // locale: 'nl',
      // page.locale?.id
    },
    ['id'],
  ) as IPageCreate;
}

export const fetchPages = async () => {
  try {
    const query = {
      '*': true,
      author: {
        id: true,
        username: true,
      },
      sections: {
        '*': true,
        files: {
          '*': true,
        },
        page: {
          id: true,
          author: {
            id: true,
            username: true,
          },
        },
      },
    } as const satisfies Retrieving<'Page'>;
    const response = await callGet('Page', query);
    return response.response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const postPageData = async (data: IPage) => {
  try {
    const response: any = await api.post('Page', prepareForCreate(data));
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const patchPageData = async (data: IPage) => {
  try {
    const response = await api.patch('Page/' + data.id, prepareForUpdate(data));
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const deletePageData = async (id: number) => {
  try {
    const response: any = await api.delete('Page/' + id);
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};
